import BaseModel from '@/models/BaseModel';
import ImageModel from '@/models/ImageModel';

class PostContentModel extends BaseModel {
  // eslint-disable-next-line
  get defaults() {
    return {
      id: null,

      step: 1,

      // focal_point: {
      //   x: 0,
      //   y: 0,
      // },

      title: '',

      subtitle: '',

      teaser: '',

      image: null,

      image_id: null,

      content: '',
    };
  }

  constructor(props = {}) {
    super(props);
    if (props.image) {
      this.image = new ImageModel(props.image);
    }
  }
}

export default PostContentModel;
